import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    inputBeds: false,
    inputBaths: false,
    inputCars: false,
    inputLotSizeRange: [0, 10000],
    inputDwellingSizeRange: [0, 10000],
    inputPriceRange: [0, 10000],
    inputLotNumber: '',
    inputBuilder: '',
    inputColourScheme: '',
    inputHouseDesign: '',
  },

  mutations: {
    SET_FILTER_PARAMETERS: (state, parameters) => {
      if (!_.isUndefined(parameters.inputBeds)) state.inputBeds = parameters.inputBeds
      if (!_.isUndefined(parameters.inputBaths)) state.inputBaths = parameters.inputBaths
      if (!_.isUndefined(parameters.inputCars)) state.inputCars = parameters.inputCars
      if (!_.isUndefined(parameters.inputLotSizeRange)) state.inputLotSizeRange = parameters.inputLotSizeRange
      if (!_.isUndefined(parameters.inputDwellingSizeRange)) state.inputDwellingSizeRange = parameters.inputDwellingSizeRange
      if (!_.isUndefined(parameters.inputPriceRange)) state.inputPriceRange = parameters.inputPriceRange
      if (!_.isUndefined(parameters.inputLotNumber)) state.inputLotNumber = parameters.inputLotNumber
      if (!_.isUndefined(parameters.inputBuilder)) state.inputBuilder = parameters.inputBuilder
      if (!_.isUndefined(parameters.inputColourScheme)) state.inputColourScheme = parameters.inputColourScheme
      if (!_.isUndefined(parameters.inputHouseDesign)) state.inputHouseDesign = parameters.inputHouseDesign
    },    

    RESET_FILTER_PARAMETERS: (state) => {
      state.inputBeds = false
      state.inputBaths = false
      state.inputCars = false
      state.inputLotSizeRange = [0, 10000]
      state.inputDwellingSizeRange = [0, 10000]
      state.inputPriceRange = [0, 10000]
      state.inputLotNumber = ''
      state.inputBuilder = ''
      state.inputColourScheme = ''
      state.inputHouseDesign = ''
    },
  },

  getters: {
    priceRanges: (state, getters, rootState, rootGetters) => {
      const pathway = rootState.route.name === 'packages' ? 'packages' : rootState.route.params.pathway
      let priceRanges = []

      // packages price ranges
      if (['packages', 'package-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsPackages'].length) {
        const minVal = _.min(rootGetters['property/livingOptionsPackages'].map(loPackage => parseInt(loPackage.price) / 1000))
        const maxVal = _.max(rootGetters['property/livingOptionsPackages'].map(loPackage => parseInt(loPackage.price) / 1000))

        if ((minVal || minVal === 0) && (maxVal || maxVal === 0)) {
          priceRanges.push(Math.floor(minVal / 50) * 50)
          priceRanges.push(Math.ceil(maxVal / 50) * 50)
        }   

        return priceRanges
      } 

      
      // dwellings price ranges
      if (['dwellings', 'dwelling-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsDwellings'].length) {
        const minVal = _.min(rootGetters['property/livingOptionsDwellings'].map(dwelling => parseInt(dwelling.price) / 1000))
        const maxVal = _.max(rootGetters['property/livingOptionsDwellings'].map(dwelling => parseInt(dwelling.price) / 1000))

        if ((minVal || minVal === 0) && (maxVal || maxVal === 0)) {
          priceRanges.push(Math.floor(minVal / 50) * 50)
          priceRanges.push(Math.ceil(maxVal / 50) * 50)
        }

        return priceRanges
      }

      if (['townhouses', 'houses'].includes(pathway)) {
        let min = rootGetters['property/activeLivingOption'].filter.dwellingPriceRange[0] / 1000
        let max = rootGetters['property/activeLivingOption'].filter.dwellingPriceRange[1] / 1000
        min = Math.floor(min / 50) * 50
        max = Math.ceil(max / 50) * 50

        return [min, max]
      }

      if (['land'].includes(pathway)) {
        if (rootGetters['property/activeLivingOption']) {
          let min = rootGetters['property/activeLivingOption'].filter.landPriceRange[0] / 1000
          let max = rootGetters['property/activeLivingOption'].filter.landPriceRange[1] / 1000
          min = Math.floor(min / 50) * 50
          max = Math.ceil(max / 50) * 50
  
          return [min, max]
        }
      }

      if (['apartments'].includes(pathway)) {
        if (rootGetters['property/activeSubsection']) {
          let min = rootGetters['property/activeSubsection'].filter.landPriceRange[0] / 1000
          let max = rootGetters['property/activeSubsection'].filter.landPriceRange[1] / 1000
          min = Math.floor(min / 50) * 50
          max = Math.ceil(max / 50) * 50
  
          return [min, max]
        }
      }

      return priceRanges
    },

    lotSizeRanges: (state, getters, rootState, rootGetters) => {
      const pathway = rootState.route.name === 'packages' ? 'packages' : rootState.route.params.pathway
      let lotSizeRanges = []

      if (['packages', 'package-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsPackages'].length) {
        const minVal = _.min(rootGetters['property/livingOptionsPackages'].map(loPackage => parseFloat(loPackage.property.size)))
        const maxVal = _.max(rootGetters['property/livingOptionsPackages'].map(loPackage => parseFloat(loPackage.property.size)))

        if ((minVal || minVal === 0) && (maxVal || maxVal === 0)) {
          lotSizeRanges.push(Math.floor(minVal / 25) * 25)
          lotSizeRanges.push(Math.ceil(maxVal / 25) * 25)
        }

        return lotSizeRanges
      } 
      
      if (['dwellings', 'dwelling-modal'].includes(rootState.route.name) && getters.dwellings.length) {
        return []
      } 

      if (['townhouses', 'land', 'houses'].includes(pathway) && rootGetters['property/activeLivingOption']) {
        let min = rootGetters['property/activeLivingOption'].filter.sizeRange[0]
        let max = rootGetters['property/activeLivingOption'].filter.sizeRange[1]
        min = Math.floor(min / 25) * 25
        max = Math.ceil(max / 25) * 25

        return [min, max]
      }

      if (['apartments'].includes(pathway) && rootGetters['property/activeSubsection']) {
        let min = rootGetters['property/activeSubsection'].filter.sizeRange[0]
        let max = rootGetters['property/activeSubsection'].filter.sizeRange[1]
        min = Math.floor(min / 25) * 25
        max = Math.ceil(max / 25) * 25

        return [min, max]
      }
    },

    dwellingSizeRanges: (state, getters, rootState, rootGetters) => {
      const pathway = rootState.route.name === 'packages' ? 'packages' : rootState.route.params.pathway
      let sizeRange = []

      if (['packages', 'package-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsPackages'].length) {
        let minVal = _.min(rootGetters['property/livingOptionsPackages'].map(loPackage => parseFloat(loPackage.dwelling.size)))
        let maxVal = _.max(rootGetters['property/livingOptionsPackages'].map(loPackage => parseFloat(loPackage.dwelling.size)))

        if (minVal || maxVal) {
          sizeRange.push(Math.floor(minVal / 25) * 25)
          sizeRange.push(Math.ceil(maxVal / 25) * 25)
        }

        return sizeRange
      }
      
      if (['dwellings', 'dwelling-modal'].includes(rootState.route.name) && rootGetters['property/dwellings'].length) {
        let minVal = _.min(rootGetters['property/livingOptionsDwellings'].map(dwelling => parseFloat(dwelling.size)))
        let maxVal = _.max(rootGetters['property/livingOptionsDwellings'].map(dwelling => parseFloat(dwelling.size)))

        minVal ? sizeRange.push(Math.floor(minVal / 25) * 25) : minVal
        maxVal ? sizeRange.push(Math.ceil(maxVal / 25) * 25) : maxVal

        return sizeRange
      }

      if (['townhouses', 'land', 'houses'].includes(pathway) && rootGetters['property/activeLivingOption']) {
        if (getters.activeProperties) {
          let propertyDwellingSizes = []
          getters.activeProperties.forEach(property => {
            if (property.dwelling && property.dwelling.size) {
              propertyDwellingSizes.push(parseInt(property.dwelling.size))
            }
          })

          sizeRange.push(...propertyDwellingSizes)
        }
        sizeRange.push(rootGetters['property/activeLivingOption'].filter.dwellingSizeRange[0], rootGetters['property/activeLivingOption'].filter.dwellingSizeRange[1])

        let min = Math.min(...sizeRange)
        let max = Math.max(...sizeRange)

        min = Math.floor(min / 25) * 25
        max = Math.ceil(max / 25) * 25

        return [min, max]
      }

      if (['apartments'].includes(pathway) && rootGetters['property/activeSubsection']) {
        if (getters.activeProperties) {
          let propertyDwellingSizes = []
          getters.activeProperties.forEach(property => {
            if (property.dwelling && property.dwelling.size) {
              propertyDwellingSizes.push(parseInt(property.dwelling.size))
            }
          })

          sizeRange.push(...propertyDwellingSizes)
        }
        sizeRange.push(rootGetters['property/activeSubsection'].filter.dwellingSizeRange[0], rootGetters['property/activeSubsection'].filter.dwellingSizeRange[1])

        let min = Math.min(...sizeRange)
        let max = Math.max(...sizeRange)

        min = Math.floor(min / 25) * 25
        max = Math.ceil(max / 25) * 25

        return [min, max]
      }
    }
  }
}
